{ "compressionlevel":-1,
 "height":14,
 "infinite":false,
 "layers":[
        {
         "draworder":"topdown",
         "id":2,
         "name":"Objects",
         "objects":[
                {
                 "height":0,
                 "id":3,
                 "name":"player",
                 "point":true,
                 "rotation":0,
                 "type":"player",
                 "visible":true,
                 "width":0,
                 "x":192,
                 "y":192
                }, 
                {
                 "ellipse":true,
                 "height":96,
                 "id":6,
                 "name":"target",
                 "rotation":0,
                 "type":"target",
                 "visible":true,
                 "width":96,
                 "x":288,
                 "y":160
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":true,
         "x":0,
         "y":0
        }],
 "nextlayerid":3,
 "nextobjectid":9,
 "orientation":"orthogonal",
 "properties":[
        {
         "name":"levelName",
         "type":"string",
         "value":"Level 1"
        }, 
        {
         "name":"order",
         "type":"int",
         "value":0
        }],
 "renderorder":"right-down",
 "tiledversion":"1.6.0",
 "tileheight":32,
 "tilesets":[],
 "tilewidth":32,
 "type":"map",
 "version":"1.6",
 "width":20
}